import { Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';

const MonitoredRoute = Sentry.withSentryRouting(Route);

export default MonitoredRoute;
